import { Activity } from "@outschool/business-rules";
import { dayjs } from "@outschool/time";

import allThingsDrawing from "../images/all-things-drawing.jpg";
import allThingsPainting from "../images/all-things-painting.jpg";
import animalsAndWildlife from "../images/animals-and-wildlife.jpg";
import ballet from "../images/ballet.jpg";
import bookClubs from "../images/book-clubs.jpg";
import circleTime from "../images/circle-time.jpg";
import codingProgramming from "../images/coding-programming.jpg";
import cookingBaking from "../images/cooking-baking.jpg";
import creativeWriting from "../images/creative-writing.jpg";
import debateSkills from "../images/debate-skills.jpg";
import dogs from "../images/dogs.jpg";
import drawingTechniques from "../images/drawing-techniques.jpg";
import dungeonsDragons from "../images/dungeons-dragons.jpg";
import escapeRooms from "../images/escape-rooms.jpg";
import exploreChemistry from "../images/explore-chemistry.jpg";
import exploreHistory from "../images/explore-history.jpg";
import exploringScience from "../images/exploring-science.jpg";
import generatedActingDrama from "../images/generated-acting-drama.jpg";
import generatedAlgebra from "../images/generated-algebra.jpg";
import generatedAmericanHistory from "../images/generated-american-history.jpg";
import generatedArtsCrafts from "../images/generated-arts-crafts.jpg";
import generatedCalculus from "../images/generated-calculus.jpg";
import generatedCartoonDrawing from "../images/generated-cartoon-drawing.jpg";
import generatedCountingNumbers from "../images/generated-counting-numbers.jpg";
import generatedDinosaurs from "../images/generated-dinosaurs.jpg";
import generatedDrawWithProcreate from "../images/generated-draw-with-procreate.jpg";
import generatedEssayWriting from "../images/generated-essay-writing.jpg";
import generatedExploreBiology from "../images/generated-explore-biology.jpg";
import generatedExploreDance from "../images/generated-explore-dance.jpg";
import generatedExploreGeography from "../images/generated-explore-geography.jpg";
import generatedExploringCareers from "../images/generated-exploring-careers.jpg";
import generatedGeometry from "../images/generated-geometry.jpg";
import generatedLearnFrench from "../images/generated-learn-french.jpg";
import generatedLearnJapanese from "../images/generated-learn-japanese.jpg";
import generatedLearnSignLanguage from "../images/generated-learn-sign-language.jpg";
import generatedLearnToDrawPeople from "../images/generated-learn-to-draw-people.jpg";
import generatedLearnToSketch from "../images/generated-learn-to-sketch.jpg";
import generatedLearningWithRoblox from "../images/generated-learning-with-roblox.jpg";
import generatedManagingEmotions from "../images/generated-managing-emotions.jpg";
import generatedMultiplication from "../images/generated-multiplication.jpg";
import generatedPhotography from "../images/generated-photography.jpg";
import generatedPlayAmongUs from "../images/generated-play-among-us.jpg";
import generatedPsychology from "../images/generated-psychology.jpg";
import generatedSpanishImmersion from "../images/generated-spanish-immersion.jpg";
import investing from "../images/investing.jpg";
import learnChinese from "../images/learn-chinese.jpg";
import learnSpanish from "../images/learn-spanish.jpg";
import learnToDrawAnimals from "../images/learn-to-draw-animals.jpg";
import learningWithMinecraft from "../images/learning-with-minecraft.jpg";
import masteringMath from "../images/mastering-math.jpg";
import moneySkills from "../images/money-skills.jpg";
import phonics from "../images/phonics.jpg";
import reading from "../images/reading.jpg";
import singing from "../images/singing.jpg";
import summerCamp from "../images/summer-camp.jpg";
import theater from "../images/theater.jpg";
import travel from "../images/travel.jpg";
import videoGames from "../images/video-games.jpg";
import workoutsFitness from "../images/workouts-fitness.jpg";
import worldHistory from "../images/world-history.jpg";
import writingSkills from "../images/writing-skills.jpg";

export const SPECIAL_TITLE = Object.freeze({
  BESTSELLERS: "Best-sellers starting soon"
} as const);

export const TOPIC_TITLE = Object.freeze({
  ACTING_DRAMA: "Acting and drama",
  ALGEBRA: "Algebra",
  AMERICAN_HISTORY: "American history",
  AMONG_US: "Play Among Us",
  ANIMALS_AND_WILDLIFE: "Animals and wildlife",
  BALLET: "Ballet",
  BIOLOGY: "Explore biology",
  BOOK_CLUBS: "Book clubs",
  CALCULUS: "Calculus",
  CAREERS: "Exploring careers",
  CARTOON_DRAWING: "Cartoon drawing",
  CHEMISTRY: "Explore chemistry",
  CHINESE: "Learn Chinese",
  CIRCLE_TIME: "Circle time",
  CODING_AND_PROGRAMING: "Coding and programming",
  COOKING_AND_BAKING: "Cooking and baking",
  COUNTING_AND_NUMBERS: "Counting and numbers",
  CRAFTS: "Arts and crafts",
  CREATIVE_WRITING: "Creative writing",
  DANCE: "Explore dance",
  DEBATE: "Debate skills",
  DINOSAURS: "Dinosaurs",
  DOGS: "Dogs",
  DRAWING: "All things drawing",
  DRAW_ANIMALS: "Learn to draw animals",
  DRAW_PEOPLE: "Learn to draw people",
  DRAWING_TECHNIQUES: "Drawing techniques",
  DUNGEONS_AND_DRAGONS: "Dungeons and Dragons",
  MANAGING_EMOTIONS: "Managing emotions",
  ESCAPE_ROOMS: "Escape rooms",
  ESSAY_WRITING: "Essay writing",
  FRENCH: "Learn French",
  VIDEO_GAMES: "Video games",
  GEOGRAPHY: "Explore geography",
  GEOMETRY: "Geometry",
  HISTORY: "Explore history",
  INVESTING: "Investing",
  JAPANESE: "Learn Japanese",
  MATH: "Mastering math",
  MINECRAFT: "Learning with Minecraft",
  MONEY: "Money skills",
  MUTLIPLICATION: "Multiplication",
  PAINTING: "All things painting",
  PHONICS: "Phonics",
  PHOTOGRAPHY: "Photography",
  PROCREATE: "Draw with Procreate",
  PSYCHOLOGY: "Psychology",
  READING: "Reading",
  ROBLOX: "Learning with Roblox",
  SCIENCE: "Exploring science",
  SIGN_LANGUAGE: "Learn sign language",
  SINGING: "Singing",
  SKETCH: "Learn to sketch",
  SPANISH: "Learn Spanish",
  SPANISH_IMMERSION: "Spanish immersion",
  THEATER: "Theater",
  WORKOUTS_AND_FITNESS: "Workouts and fitness",
  WORLD_HISTORY: "World history",
  WRITING: "Writing skills",
  SUMMER_CAMPS: "Summer camps",
  TRAVEL: "Travel the globe"
} as const);

export const SpecialCardDefinitions = [
  {
    id: "bestsellers-starting-soon",
    title: SPECIAL_TITLE.BESTSELLERS,
    searchFilters: {
      startAfter: dayjs().toDate(),
      startBefore: dayjs().add(4, "hours").toDate(),
      delivery: Activity.DeliveryTypeValues.OneTimeClass,
      order: "popular",
      activityRatingMin: 4.8,
      teacherRatingMin: 4.5,
      q: ""
    },
    display: "list",
    criteria: {
      weightsByAge: {
        "100": []
      }
    }
  }
];

export const TopicDefinitions = [
  {
    id: "acting-drama",
    title: TOPIC_TITLE.ACTING_DRAMA,
    imageUrl: generatedActingDrama,
    searchFilters: {
      q: "Acting"
    },
    criteria: {
      alignment: "Socializing",
      weightsByAge: {
        "100": [6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18],
        "200": [13, 14],
        "300": []
      }
    }
  },
  {
    id: "algebra",
    title: TOPIC_TITLE.ALGEBRA,
    imageUrl: generatedAlgebra,
    searchFilters: {
      q: "Algebra"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [],
        "200": [12, 13, 14, 15, 16, 17, 18],
        "300": []
      }
    }
  },
  {
    id: "american-history",
    title: TOPIC_TITLE.AMERICAN_HISTORY,
    imageUrl: generatedAmericanHistory,
    searchFilters: {
      q: "American History"
    },
    criteria: {
      alignment: "History",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "play-among-us",
    title: TOPIC_TITLE.AMONG_US,
    imageUrl: generatedPlayAmongUs,
    searchFilters: {
      q: "Among Us"
    },
    criteria: {
      alignment: "Video Games",
      weightsByAge: {
        "100": [12, 13, 15, 16, 17, 18],
        "200": [8, 9, 10, 11, 14],
        "300": []
      }
    }
  },
  {
    id: "animals-and-wildlife",
    title: TOPIC_TITLE.ANIMALS_AND_WILDLIFE,
    imageUrl: animalsAndWildlife,
    searchFilters: {
      q: "Animals"
    },
    criteria: {
      alignment: "Animals",
      weightsByAge: {
        "100": [],
        "200": [11, 12, 13],
        "300": [3, 4, 5, 6, 7, 8, 9, 10]
      }
    }
  },
  {
    id: "ballet",
    title: TOPIC_TITLE.BALLET,
    imageUrl: ballet,
    searchFilters: {
      q: "Ballet"
    },
    criteria: {
      alignment: "Dance",
      weightsByAge: {
        "100": [7],
        "200": [5, 6],
        "300": [3, 4]
      }
    }
  },
  {
    id: "explore-biology",
    title: TOPIC_TITLE.BIOLOGY,
    imageUrl: generatedExploreBiology,
    searchFilters: {
      q: "Biology"
    },
    criteria: {
      alignment: "Science",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "book-clubs",
    title: TOPIC_TITLE.BOOK_CLUBS,
    imageUrl: bookClubs,
    searchFilters: {
      q: "Book Clubs"
    },
    criteria: {
      alignment: "Reading",
      weightsByAge: {
        "100": [],
        "200": [6, 7, 8, 9, 10, 11, 12],
        "300": []
      }
    }
  },
  {
    id: "calculus",
    title: TOPIC_TITLE.CALCULUS,
    imageUrl: generatedCalculus,
    searchFilters: {
      q: "Calculus"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [14, 15, 16, 17, 18],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "exploring-careers",
    title: TOPIC_TITLE.CAREERS,
    imageUrl: generatedExploringCareers,
    searchFilters: {
      q: "Careers"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "cartoon-drawing",
    title: TOPIC_TITLE.CARTOON_DRAWING,
    imageUrl: generatedCartoonDrawing,
    searchFilters: {
      q: "Cartoon Drawing"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [8],
        "200": [9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "explore-chemistry",
    title: TOPIC_TITLE.CHEMISTRY,
    imageUrl: exploreChemistry,
    searchFilters: {
      q: "Chemistry"
    },
    criteria: {
      alignment: "Science",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [14],
        "300": []
      }
    }
  },
  {
    id: "learn-chinese",
    title: TOPIC_TITLE.CHINESE,
    imageUrl: learnChinese,
    searchFilters: {
      q: "Chinese"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [6],
        "200": [3, 4, 5],
        "300": []
      }
    }
  },
  {
    id: "circle-time",
    title: TOPIC_TITLE.CIRCLE_TIME,
    imageUrl: circleTime,
    searchFilters: {
      q: "Circle Time"
    },
    criteria: {
      alignment: "Socializing",
      weightsByAge: {
        "100": [],
        "200": [5, 6],
        "300": [3, 4]
      }
    }
  },
  {
    id: "coding-programming",
    title: TOPIC_TITLE.CODING_AND_PROGRAMING,
    imageUrl: codingProgramming,
    searchFilters: {
      q: "Coding"
    },
    criteria: {
      alignment: "Programming",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [7, 8, 9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "cooking-baking",
    title: TOPIC_TITLE.COOKING_AND_BAKING,
    imageUrl: cookingBaking,
    searchFilters: {
      q: "Cooking"
    },
    criteria: {
      alignment: "Cooking",
      weightsByAge: {
        "100": [10, 11, 13, 14, 15, 16, 17, 18],
        "200": [12],
        "300": []
      }
    }
  },
  {
    id: "counting-numbers",
    title: TOPIC_TITLE.COUNTING_AND_NUMBERS,
    imageUrl: generatedCountingNumbers,
    searchFilters: {
      q: "Counting"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [],
        "200": [3, 4],
        "300": []
      }
    }
  },
  {
    id: "arts-crafts",
    title: TOPIC_TITLE.CRAFTS,
    imageUrl: generatedArtsCrafts,
    searchFilters: {
      q: "Crafts"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [3, 5, 6],
        "200": [4],
        "300": []
      }
    }
  },
  {
    id: "creative-writing",
    title: TOPIC_TITLE.CREATIVE_WRITING,
    imageUrl: creativeWriting,
    searchFilters: {
      q: "Creative Writing"
    },
    criteria: {
      alignment: "Writing",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [7, 8, 9, 10, 11, 12],
        "300": []
      }
    }
  },
  {
    id: "explore-dance",
    title: TOPIC_TITLE.DANCE,
    imageUrl: generatedExploreDance,
    searchFilters: {
      q: "Dance"
    },
    criteria: {
      alignment: "Dance",
      weightsByAge: {
        "100": [],
        "200": [4, 6, 7, 8],
        "300": [3, 5]
      }
    }
  },
  {
    id: "debate-skills",
    title: TOPIC_TITLE.DEBATE,
    imageUrl: debateSkills,
    searchFilters: {
      q: "Debate"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [10, 11, 13],
        "200": [12],
        "300": []
      }
    }
  },
  {
    id: "dinosaurs",
    title: TOPIC_TITLE.DINOSAURS,
    imageUrl: generatedDinosaurs,
    searchFilters: {
      q: "Dinosaurs"
    },
    criteria: {
      alignment: "Animals",
      weightsByAge: {
        "100": [],
        "200": [3, 4, 5, 6],
        "300": []
      }
    }
  },
  {
    id: "dogs",
    title: TOPIC_TITLE.DOGS,
    imageUrl: dogs,
    searchFilters: {
      q: "Dogs"
    },
    criteria: {
      alignment: "Animals",
      weightsByAge: {
        "100": [9],
        "200": [6, 7, 8],
        "300": []
      }
    }
  },
  {
    id: "all-things-drawing",
    title: TOPIC_TITLE.DRAWING,
    imageUrl: allThingsDrawing,
    searchFilters: {
      q: "Drawing"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [3, 14],
        "300": [4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
      }
    }
  },
  {
    id: "learn-to-draw-animals",
    title: TOPIC_TITLE.DRAW_ANIMALS,
    imageUrl: learnToDrawAnimals,
    searchFilters: {
      q: "Drawing Animals"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [],
        "200": [4, 5, 6, 7, 8, 9, 10, 11, 12],
        "300": []
      }
    }
  },
  {
    id: "learn-to-draw-people",
    title: TOPIC_TITLE.DRAW_PEOPLE,
    imageUrl: generatedLearnToDrawPeople,
    searchFilters: {
      q: "Drawing People"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [9, 10, 12, 13, 14, 15, 16, 17, 18],
        "200": [11],
        "300": []
      }
    }
  },
  {
    id: "drawing-techniques",
    title: TOPIC_TITLE.DRAWING_TECHNIQUES,
    imageUrl: drawingTechniques,
    searchFilters: {
      q: "Drawing Technique"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [7, 8, 9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "dungeons-dragons",
    title: TOPIC_TITLE.DUNGEONS_AND_DRAGONS,
    imageUrl: dungeonsDragons,
    searchFilters: {
      q: "Dungeons and Dragons"
    },
    criteria: {
      alignment: "Socializing",
      weightsByAge: {
        "100": [10, 11, 14, 15, 16, 17, 18],
        "200": [12, 13],
        "300": []
      }
    }
  },
  {
    id: "managing-emotions",
    title: TOPIC_TITLE.MANAGING_EMOTIONS,
    imageUrl: generatedManagingEmotions,
    searchFilters: {
      q: "Emotions"
    },
    criteria: {
      alignment: "Emotions",
      weightsByAge: {
        "100": [9],
        "200": [6, 7, 8],
        "300": []
      }
    }
  },
  {
    id: "escape-rooms",
    title: TOPIC_TITLE.ESCAPE_ROOMS,
    imageUrl: escapeRooms,
    searchFilters: {
      q: "Escape Room"
    },
    criteria: {
      alignment: "Puzzles",
      weightsByAge: {
        "100": [5, 12],
        "200": [4, 6, 7, 8, 9, 10, 11],
        "300": []
      }
    }
  },
  {
    id: "essay-writing",
    title: TOPIC_TITLE.ESSAY_WRITING,
    imageUrl: generatedEssayWriting,
    searchFilters: {
      q: "Essay Writing"
    },
    criteria: {
      alignment: "Writing",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "learn-french",
    title: TOPIC_TITLE.FRENCH,
    imageUrl: generatedLearnFrench,
    searchFilters: {
      q: "French"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [5, 6, 7, 8, 9, 10, 11, 12],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "video-games",
    title: TOPIC_TITLE.VIDEO_GAMES,
    imageUrl: videoGames,
    searchFilters: {
      q: "Gaming"
    },
    criteria: {
      alignment: "Video Games",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [7, 8, 9, 10, 11, 12, 14],
        "300": []
      }
    }
  },
  {
    id: "explore-geography",
    title: TOPIC_TITLE.GEOGRAPHY,
    imageUrl: generatedExploreGeography,
    searchFilters: {
      q: "Geography"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [10, 11],
        "200": [5, 6, 7, 8, 9, 12, 13],
        "300": []
      }
    }
  },
  {
    id: "geometry",
    title: TOPIC_TITLE.GEOMETRY,
    imageUrl: generatedGeometry,
    searchFilters: {
      q: "Geometry"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [14],
        "300": []
      }
    }
  },
  {
    id: "explore-history",
    title: TOPIC_TITLE.HISTORY,
    imageUrl: exploreHistory,
    searchFilters: {
      q: "History"
    },
    criteria: {
      alignment: "History",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [6, 7, 8, 9, 10, 11, 12],
        "300": [13, 14]
      }
    }
  },
  {
    id: "investing",
    title: TOPIC_TITLE.INVESTING,
    imageUrl: investing,
    searchFilters: {
      q: "Investing"
    },
    criteria: {
      alignment: "Money skills",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "learn-japanese",
    title: TOPIC_TITLE.JAPANESE,
    imageUrl: generatedLearnJapanese,
    searchFilters: {
      q: "Japanese"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [12, 13, 15, 16, 17, 18],
        "200": [14],
        "300": []
      }
    }
  },
  {
    id: "mastering-math",
    title: TOPIC_TITLE.MATH,
    imageUrl: masteringMath,
    searchFilters: {
      q: "Math"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [],
        "200": [7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18],
        "300": [3, 4, 5, 6, 14]
      }
    }
  },
  {
    id: "learning-with-minecraft",
    title: TOPIC_TITLE.MINECRAFT,
    imageUrl: learningWithMinecraft,
    searchFilters: {
      q: "Minecraft"
    },
    criteria: {
      alignment: "Video Games",
      weightsByAge: {
        "100": [13],
        "200": [6, 7, 8, 9, 10, 11, 12],
        "300": []
      }
    }
  },
  {
    id: "money-skills",
    title: TOPIC_TITLE.MONEY,
    imageUrl: moneySkills,
    searchFilters: {
      q: "Money"
    },
    criteria: {
      alignment: "Money skills",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [14],
        "300": []
      }
    }
  },
  {
    id: "multiplication",
    title: TOPIC_TITLE.MUTLIPLICATION,
    imageUrl: generatedMultiplication,
    searchFilters: {
      q: "Multiplication"
    },
    criteria: {
      alignment: "Math",
      weightsByAge: {
        "100": [7, 11, 12],
        "200": [8, 9, 10, 13],
        "300": []
      }
    }
  },
  {
    id: "all-things-painting",
    title: TOPIC_TITLE.PAINTING,
    imageUrl: allThingsPainting,
    searchFilters: {
      q: "Painting"
    },
    criteria: {
      alignment: "Painting",
      weightsByAge: {
        "100": [11, 13],
        "200": [5, 6, 7, 8, 9, 10, 12],
        "300": []
      }
    }
  },
  {
    id: "phonics",
    title: TOPIC_TITLE.PHONICS,
    imageUrl: phonics,
    searchFilters: {
      q: "Phonics"
    },
    criteria: {
      alignment: "Reading",
      weightsByAge: {
        "100": [],
        "200": [3, 6, 7],
        "300": [4, 5]
      }
    }
  },
  {
    id: "photography",
    title: TOPIC_TITLE.PHOTOGRAPHY,
    imageUrl: generatedPhotography,
    searchFilters: {
      q: "Photography"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [10, 11, 12, 13, 14],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "draw-with-procreate",
    title: TOPIC_TITLE.PROCREATE,
    imageUrl: generatedDrawWithProcreate,
    searchFilters: {
      q: "Procreate"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [10, 11, 12, 13, 14],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "psychology",
    title: TOPIC_TITLE.PSYCHOLOGY,
    imageUrl: generatedPsychology,
    searchFilters: {
      q: "Psychology"
    },
    criteria: {
      alignment: "Emotions",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [],
        "300": []
      }
    }
  },
  {
    id: "reading",
    title: TOPIC_TITLE.READING,
    imageUrl: reading,
    searchFilters: {
      q: "Reading"
    },
    criteria: {
      alignment: "Reading",
      weightsByAge: {
        "100": [13],
        "200": [3, 8, 9, 10, 11, 12, 14],
        "300": [4, 5, 6, 7]
      }
    }
  },
  {
    id: "learning-with-roblox",
    title: TOPIC_TITLE.ROBLOX,
    imageUrl: generatedLearningWithRoblox,
    searchFilters: {
      q: "Roblox"
    },
    criteria: {
      alignment: "Video Games",
      weightsByAge: {
        "100": [6, 12],
        "200": [7, 8, 9, 10, 11],
        "300": []
      }
    }
  },
  {
    id: "exploring-science",
    title: TOPIC_TITLE.SCIENCE,
    imageUrl: exploringScience,
    searchFilters: {
      q: "Science"
    },
    criteria: {
      alignment: "Science",
      weightsByAge: {
        "100": [],
        "200": [15, 16, 17, 18],
        "300": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
      }
    }
  },
  {
    id: "learn-sign-language",
    title: TOPIC_TITLE.SIGN_LANGUAGE,
    imageUrl: generatedLearnSignLanguage,
    searchFilters: {
      q: "Sign Language"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [13, 15, 16, 17, 18],
        "200": [14],
        "300": []
      }
    }
  },
  {
    id: "singing",
    title: TOPIC_TITLE.SINGING,
    imageUrl: singing,
    searchFilters: {
      q: "Singing"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "100": [7],
        "200": [3, 5, 6],
        "300": [4]
      }
    }
  },
  {
    id: "learn-to-sketch",
    title: TOPIC_TITLE.SKETCH,
    imageUrl: generatedLearnToSketch,
    searchFilters: {
      q: "Sketching"
    },
    criteria: {
      alignment: "Drawing",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [8, 9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "learn-spanish",
    title: TOPIC_TITLE.SPANISH,
    imageUrl: learnSpanish,
    searchFilters: {
      q: "Spanish"
    },
    criteria: {
      alignment: "Spanish",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        "300": [4]
      }
    }
  },
  {
    id: "spanish-immersion",
    title: TOPIC_TITLE.SPANISH_IMMERSION,
    imageUrl: generatedSpanishImmersion,
    searchFilters: {
      q: "Spanish Immersion"
    },
    criteria: {
      alignment: "Spanish",
      weightsByAge: {
        "100": [3, 5, 6, 7],
        "200": [4],
        "300": []
      }
    }
  },
  {
    id: "theater",
    title: TOPIC_TITLE.THEATER,
    imageUrl: theater,
    searchFilters: {
      q: "Theater"
    },
    criteria: {
      alignment: "Socializing",
      weightsByAge: {
        "100": [5, 9, 10, 12, 15, 16, 17, 18],
        "200": [6, 7, 8, 11, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "workouts-fitness",
    title: TOPIC_TITLE.WORKOUTS_AND_FITNESS,
    imageUrl: workoutsFitness,
    searchFilters: {
      q: "Workout & Fitness"
    },
    criteria: {
      alignment: "Workouts",
      weightsByAge: {
        "100": [6],
        "200": [3, 4, 5],
        "300": []
      }
    }
  },
  {
    id: "world-history",
    title: TOPIC_TITLE.WORLD_HISTORY,
    imageUrl: worldHistory,
    searchFilters: {
      q: "World History"
    },
    criteria: {
      alignment: "History",
      weightsByAge: {
        "100": [8, 15, 16, 17, 18],
        "200": [9, 10, 11, 12, 13, 14],
        "300": []
      }
    }
  },
  {
    id: "writing-skills",
    title: TOPIC_TITLE.WRITING,
    imageUrl: writingSkills,
    searchFilters: {
      q: "Writing"
    },
    criteria: {
      alignment: "Writing",
      weightsByAge: {
        "100": [15, 16, 17, 18],
        "200": [4, 5, 6, 8, 9, 10, 11, 12, 13, 14],
        "300": [7]
      }
    }
  },
  {
    id: "summer-camps",
    title: TOPIC_TITLE.SUMMER_CAMPS,
    imageUrl: summerCamp,
    searchFilters: {
      q: "summer-camps"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "1000": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
      },
      dates: {
        to: "2022-07-15"
      }
    }
  },
  {
    id: "travel",
    title: TOPIC_TITLE.TRAVEL,
    imageUrl: travel,
    searchFilters: {
      q: "travel"
    },
    criteria: {
      alignment: "",
      weightsByAge: {
        "300": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
      }
    }
  }
];

export default [...SpecialCardDefinitions, ...TopicDefinitions];
